import React, {FC, ReactNode} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {
  InfoBanner,
  InfoBannerTypesEnum,
} from '../../../../../libs/shared/ui/src/components/banners/infoBanner/infoBanner';

/*
 * Const.
 */

const DEFAULT_ERROR_MESSAGE = (
  <Trans id="analytics-report-error">
    Oops, something went wrong! Please try reloading, if this persists please contact support.
  </Trans>
);

/*
 * Props.
 */

interface ReportErrorBannerProps {
  message?: ReactNode;
  className?: string;
}

/*
 * Component.
 */

export const ReportErrorBanner: FC<ReportErrorBannerProps> = ({
  message = DEFAULT_ERROR_MESSAGE,
  className,
}) => <InfoBanner type={InfoBannerTypesEnum.ERROR} title={message} className={className} />;
